import type { Form } from "../types/formTypes";

export function FormMetadata({ form }: { form: Form }) {
  return (
    <span className="inline-flex flex-wrap gap-x-4 gap-y-1">
      <span>Last updated <time dateTime={form.modifiedAt.toISOString()}>{form.modifiedAt.toLocaleString(undefined, {
        dateStyle: "medium", timeStyle: "short",
      })}</time></span>
      <span>Version {form.version}</span>
    </span>
  );
}
